import { LanguageSupport, LRLanguage } from '@codemirror/language';
import { FormattedMessage } from 'react-intl';

import { filterFieldParser } from '../parser/filterfield-parser.js';
import type { FilterFieldSuggestion } from '../suggestions/Suggestion.js';

const filterFieldLanguage = LRLanguage.define({
  parser: filterFieldParser,
  name: 'FilterFieldLang',
});

/** @internal */
export const defaultLogicalOperatorSuggestions: FilterFieldSuggestion[] = [
  { value: 'OR' },
];

/** @internal */
export const operatorSuggestionsWithDetails: Record<
  string,
  FilterFieldSuggestion
> = {
  in: {
    value: 'in (',
    displayValue: 'in ()',
    details: (
      <FormattedMessage
        defaultMessage="Matches one or more values in a list of values"
        id="sL31KseaKVCE9eh0"
        description="Filter field exists operator description"
      />
    ),
    trailing: ') ',
    cursorBeforeTrailing: true,
  },
  'not in': {
    value: 'not in (',
    displayValue: 'not in ()',
    details: (
      <FormattedMessage
        defaultMessage="Doesn't match one or more values in a list of values"
        id="lp/ioP9LPaFPCj/K"
        description="Filter field exists operator description"
      />
    ),
    trailing: ') ',
    cursorBeforeTrailing: true,
  },
  '= *': {
    value: '= *',
    details: (
      <FormattedMessage
        defaultMessage="Exists in any form"
        id="RSp2nSscx4hJgP2P"
        description="Filter field exists operator description"
      />
    ),
  },
  '!= *': {
    value: '!= *',
    details: (
      <FormattedMessage
        defaultMessage="Doesn't exist in any form"
        id="E1oTbKDAzXJo/hs/"
        description="Filter field not exists operator description"
      />
    ),
  },
  '~': {
    value: '~',
    details: (
      <FormattedMessage
        defaultMessage="Matches phrase"
        id="TNgy+4XtLPGHfZu2"
        description="Filter field matches-phrase operator description"
      />
    ),
  },
  '!~': {
    value: '!~',
    details: (
      <FormattedMessage
        defaultMessage="Does not match phrase"
        id="Tr/buzcgyjaGCFM7"
        description="Filter field not-matches-phrase operator description"
      />
    ),
  },
};

/** @internal */
export const filterFieldLanguageExtension = new LanguageSupport(
  filterFieldLanguage,
);
